<template>
  <div class="evaluation-edit">

    <el-card class="evaluation-prize-main" v-if="permissionFn('write')">
      <div slot="header">
          <el-page-header @back="$router.push('/evaluation')" content=""></el-page-header>
      </div>
      <h1>{{year}}年度评优候选推荐意见收集</h1>
      <div class="desc">请根据以下奖项及评选标准，结合本部门员工年度考评情况进行推荐。具体需在对应奖项下方填写推荐人员姓名、推荐理由、推荐人员表现的信息，以便评委参考。</div>
      <!-- <div>
        所属部门：<el-input v-model="department" class="department"></el-input>
      </div> -->
      <div class="card-list">
         <div class="card-item" v-for="(item,index) in prizeList" :key="item.id">
           <h2>{{index+1}}、{{item.name}}</h2>
           <div class="desc-list">
             <template v-for="describe in Object.keys(item).filter(x=>x.startsWith('describe'))">
               <div :key="describe">
                <h3>{{describeOptions[describe]}}</h3>
                <p v-html="item[describe]"></p>
              </div>
             </template>
           </div>
            <el-table
              border
              :data="tableData[item.id]"
              style="width: 100%"
              :key="key"
              >
              <el-table-column
                prop="name"
                label="候选人员姓名"
                width="180">
                <template slot-scope="scope">
                  {{scope.row.name}}
                </template>
              </el-table-column>
              <el-table-column
                prop="reason"
                label="部门推荐理由">
                <template slot-scope="scope">
                  {{scope.row.reason}}
                </template>
              </el-table-column>
              <el-table-column
                prop="describe"
                label="候选人表现描述（以具体事例/数据说明）">
                <template slot-scope="scope">
                  {{scope.row.describe}}
                </template>
              </el-table-column>
               <el-table-column
                prop="describe"
                label="推荐人">
                <template slot-scope="scope">
                  {{scope.row.recommander}}
                </template>
              </el-table-column>
            </el-table>
         </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import permissionMixins from '@/mixins/permission'
export default {
  mixins: [permissionMixins],
  data() {
    return {
      department: '',
      prizeList: [],
      tableData: {},
      key: '',
      deleteJson: {},
      describeOptions: {
        describe: '奖项意义',
        describe2: '评选标准',
        describe3: '评选方式'
      }
    }
  },
  computed: {
    creatable() { return +this.$route.params.id === 0 },
    year() {
      return new Date().getFullYear()
    }
  },
  methods: {
    init() {
      this.tableData = {}
      this.$http.post('/activity/list').then(res => {
        this.prizeList = res.data.data
        this.$http.post('/activity/join_list').then(res => {
          if (res.data.data && res.data.data.length) {
            res.data.data.forEach(item => {
              !this.tableData[item.id] && (this.tableData[item.id] = [])
              this.tableData[item.id].push(item)
            })
          }
          this.prizeList.forEach(item => {
            !this.tableData[item.id] && (this.tableData[item.id] = [])
            const len = this.tableData[item.id].length || 0
            len < 3 && (this.tableData[item.id] = this.tableData[item.id])
          })
          this.key = Date.now()
        })
      })
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss">
.evaluation-edit {
  .el-page-header{
    border-bottom:none;
    padding:0;
  }
  h1{
    text-align:center;
    line-height: 1.5;
    font-size:18px;
    padding-bottom:10px;
  }
  .tr{
    text-align:right;
  }
  .tc{
      text-align: center;
  }
  .desc,
  .desc-list{
    line-height: 1.5;
    padding-bottom:20px;

  }
  .desc-list{
    padding-left:20px;
    h3{
      // font-weight: bold;
      margin: 15px 0 5px;
      position: relative;
      padding-left: 15px;
      font-weight: 600;
      &:before{
        content:'';
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #666;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -2.5px;
      }
    }
  }
  .department{
    width:200px;
    margin-bottom:20px;
  }
  .card-list{
    h2{
      margin-bottom:10px;
      font-size: 18px;
      color: #000;
      font-weight: 600;
    }
    .el-table{
      margin:20px 0 40px;
      input,
      textarea{
        border-color: #ebebeb;
        border:none;
        resize:none;
        padding:5px;
      }
    }
  }
}
</style>
